import { render, staticRenderFns } from "./create2.vue?vue&type=template&id=60994647&"
import script from "./create2.vue?vue&type=script&lang=js&"
export * from "./create2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports